<template>
  <div class="bargin-dialog" v-if="dialogVisible">
    <audio ref="audio" src="@/assets/bargin.mp3"></audio>
    <lottie
      class="lottie"
      :width="400"
      :height="400"
      :options="defaultOptions"
      @animCreated="(val) => (animation = val)"
    ></lottie>
    <el-dialog
      :visible.sync="showDialog"
      custom-class="sincerely"
      :close-on-click-modal="false"
      title="游严选诚意买"
      width="422px"
      height="408px"
      :show-close="false"
      :modal="false"
      top="30vh"
      center
    >
      <template v-if="step === 1">
        <div class="boss">尊敬的老板：</div>
        <div class="text">
          求降价需支付<span class="text-tip">一定诚意买金额</span
          >，金额越高，卖家还价或成交的概率就越大哦，求降价不成功诚意买金额将原路退回！
        </div>
        <div class="price">
          <div class="price-left">
            <img
              src="@/assets/image/bargin/bargin-logo.png"
              alt=""
              class="price-logo"
            />
            <div class="price-label">诚意买</div>
          </div>
          <el-input
            v-model="earnest_amount"
            placeholder="请输入金额"
            :maxlength="7"
          ></el-input>
          <div class="suffix">{{ range.min }}-{{ range.max }}元</div>
        </div>
        <div class="tips">
          提示：自定义金额不得低于{{ range.min }}元，不得高于号价的{{
            range.high_num
          }}%
        </div>
      </template>
      <template v-else>
        <div class="order">
          <div class="order-info">
            <span class="suffix">¥</span>
            <span class="order-price">{{ form.earnest_amount }}</span>
          </div>
          <div class="order-tips">
            <img src="@/assets/image/bargin/bargin-logo.png" alt="" />
            <div class="order-tips-text">
              诚意买为当前商品价格的{{ form.earnest_percent }}%
            </div>
          </div>
          <el-form
            label-position="left"
            label-suffix="："
            :model="form"
            size="small"
          >
            <el-form-item label="订单编号">
              {{ form.earnest_order_no }}
            </el-form-item>
            <el-form-item label="商品编号">
              {{ form.unique_no }}
            </el-form-item>
            <el-form-item label="商品名称">
              {{ form.product_name }}
            </el-form-item>
            <el-form-item label="商品价格">
              {{ form.product_price }}元
            </el-form-item>
          </el-form>
        </div>
      </template>
      <template slot="footer">
        <el-button @click="btnClick">{{
          step === 1 ? "确定" : "去支付"
        }}</el-button>
      </template>
      <img
        class="close"
        src="@/assets/image/AccountDeal/close.png"
        alt=""
        @click="closeDialog"
      />
    </el-dialog>
  </div>
</template>

<script>
import lottie from "vue-lottie";
import * as animationData from "@/assets/json/bargin.json";
import { earnestCreate, paymentPrepare } from "@/request/API";
export default {
  components: {
    lottie,
  },
  props: {
    range: {
      type: Object,
      default: () => ({
        min: "",
        max: "",
        high_num: "",
      }),
    },
  },
  data() {
    return {
      // 动画实例
      animation: null,
      // 动画配置项
      defaultOptions: {
        animationData: animationData.default,
        loop: false,
        autoplay: false,
      },
      dialogVisible: false,
      showDialog: false,
      earnest_amount: "",
      step: 1,
      form: {
        earnest_order_no: "",
        unique_no: "",
        product_name: "",
        earnest_amount: "",
        product_price: "",
        order_id: "",
      },
      product_id: "",
      game_id: "",
    };
  },
  computed: {
    percent() {
      return 1;
    },
  },
  created() {
    this.product_id = this.$route.query.id;
    this.game_id = this.$route.query.game_id;
  },
  watch: {
    dialogVisible(val) {
      if (!val) {
        this.earnest_amount = "";
        this.step = 1;
        this.form = {
          earnest_order_no: "",
          unique_no: "",
          product_name: "",
          earnest_amount: "",
          product_price: "",
          order_id: "",
        };
        this.touchmoveY();
      } else {
        this.touchmoveDisable();
        let timer = setTimeout(() => {
          this.showDialog = true;
          clearTimeout(timer);
        }, 2300);
      }
    },
    animation(val) {
      val.play();
      this.$nextTick(() => {
        // 播放音频
        this.$refs.audio.play();
      });
    },
  },
  methods: {
    /**
     * @description: 禁止页面滑动
     * @return {*}
     */
    touchmoveDisable() {
      let body = document.getElementsByTagName("body");
      body[0].style.overflow = "hidden";
    },
    /**
     * @description: 页面滑动
     * @return {*}
     */
    touchmoveY() {
      let body = document.getElementsByTagName("body");
      body[0].style.removeProperty("overflow");
    },
    // 关闭弹窗
    closeDialog() {
      this.dialogVisible = false;
      this.showDialog = false;
    },
    // 按钮确定
    btnClick() {
      switch (this.step) {
        case 1:
          var reg = /^\d+$/;
          if (!reg.test(this.earnest_amount)) {
            return this.$message.error("诚意买金额不支持小数、负数和字符");
          }
          if (
            this.earnest_amount < this.range.min ||
            this.earnest_amount > this.range.max
          ) {
            return this.$message.error(
              `当前金额已超出诚意买范围（10～${this.range.max}）`
            );
          }
          earnestCreate({
            earnest_amount: this.earnest_amount,
            game_id: this.game_id,
            product_id: this.product_id,
          })
            .then((res) => {
              this.step++;
              this.form = { ...res.data, order_id: res.data.id };
            })
            .catch((err) => {
              this.$message.error(err.msg);
              // 商品二次编辑   下架  改价 10012 跳详情页 10013 跳列表页
              if (err?.code === 10012 || err?.code === 10013) {
                this.redirect(err.code);
              }
            });
          break;
        case 2:
          paymentPrepare({ order_id: this.form.id })
            .then((res) => {
              // 收银台 支付定金
              this.closeDialog();
              let { href } = this.$router.resolve({
                name: "MethodOfPayment",
                query: {
                  type: 3,
                  orderid: this.form.order_id,
                  id: this.product_id,
                  gameid: this.game_id,
                  amount: this.form.earnest_amount,
                },
              });
              window.open(href, "_blank");
            })
            .catch((err) => {
              // 商品二次编辑   下架  改价 10012 跳详情页 10013 跳列表页
              if (err?.code === 10012 || err?.code === 10013) {
                this.redirect(err.code);
              }
              this.$message({
                message: err.msg,
                type:'error'
              });
            });
          break;
      }
    },
    // 重定向
    redirect(code) {
      switch (code) {
        case 10012:
          this.$emit('reFresh')
          this.dialogVisible = false
          break;
        case 10013:
          this.$router.push({
            name: "SelectGame",
            query: {
              game_id: this.form.game_id,
              game_alias: this.form.game_id == "26" ? "yuanshen5" : "games",
            },
          });
          break;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.el-dialog__wrapper {
  overflow: hidden;
}

@keyframes box-scale {
  0% {
    opacity: 0;
    transform: scale(0);
  }
  25% {
    opacity: 0.25;
    transform: scale(0.25);
  }
  50% {
    opacity: 0.5;
    transform: scale(0.5);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}
/deep/ .sincerely {
  text-align: left;
  font-family: PingFang SC;
  border-radius: 4px;
  background: #fff;
  position: relative;
  background-image: url("~@/assets/image/bargin/dialog-bg.png");
  background-size: 100%;
  position: relative;
  // transform: scale(0.5);
  animation: box-scale 0.5s linear 0s;
  animation-fill-mode: forwards;
  animation-iteration-count: 1;
  // &::after,
  // &::before {
  //   content: "";
  //   position: absolute;
  //   background-position: 0 0;
  //   background-size: cover;
  //   pointer-events: none;
  // }
  // &::after {
  //   width: 180%;
  //   height: 180%;
  //   top: -40%;
  //   left: -40%;
  //   // transform: scale(4) t;
  //   background-image: url("~@/assets/image/bargin/launch.png");
  //   // animation: ani-circle 0.5s linear 0s;
  //   animation-fill-mode: forwards;
  //   animation-iteration-count: 1;
  // }
  // &::before {
  //   width: 160%;
  //   height: 190%;
  //   top: -45%;
  //   left: -30%;
  //   background-position-y: -200px;
  //   background-image: url("~@/assets/image/bargin/circle.png");
  //   animation: ani-launch 0.5s linear 0s;
  //   animation-fill-mode: forwards;
  //   animation-iteration-count: 1;
  // }
  .el-dialog__header {
    text-align: center;
    padding-bottom: 0;
    .el-dialog__title {
      font-size: 20px;
      font-weight: 500;
      letter-spacing: 0.5px;
    }
    .el-dialog__headerbtn {
      top: 24px;
    }
  }
  .el-dialog__body {
    padding: 30px 20px 20px;
    .boss {
      color: #4f4f4f;
      font-weight: 600;
    }
    .text {
      font-family: PingFang SC;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      letter-spacing: 1px;
      .text-tip {
        color: #f08c2b;
      }
    }
    .price {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 32px;
      position: relative;
      &-left {
        display: flex;
      }
      &-logo {
        width: 22px;
        height: 22px;
      }
      &-label {
        color: #353535;
        font-weight: 500;
        font-size: 16px;
        letter-spacing: 0.5px;
      }
      .el-input {
        width: 283px;
      }
      .el-input-number {
        width: unset;
      }
      .suffix {
        position: absolute;
        right: 10px;
        top: 1px;
        color: #b8b8b8;
        font-weight: 300;
        background: #fff;
        height: 38px;
        line-height: 38px;
      }
    }
    .tips {
      margin-top: 10px;
      padding: 6px 14px;
      border-radius: 4px;
      text-align: center;
      background: rgba(232, 247, 255, 0.5);
      color: #D8D2CA;
    }
    .order {
      padding: 0 20px;
      &-info {
        text-align: center;
        font-weight: 600;
        color: #ff7321;
        .suffix {
          font-size: 23px;
        }
        .order-price {
          font-size: 42px;
        }
      }
      &-tips {
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 4px;
        background: rgba(232, 247, 255, 0.5);
        padding: 6px 14px;
        margin-bottom: 20px;
        img {
          width: 20px;
          height: 20px;
          margin-right: 10px;
        }
        &-text {
          color: #D8D2CA;
          font-weight: 400;
        }
      }
      .el-form {
        &-item {
          margin-bottom: 0;
          &__label {
            color: #999;
            font-weight: 400;
          }
          &__content {
            color: #353535;
            font-size: 14px;
            font-style: normal;
            font-weight: 500;
            letter-spacing: 0.5px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
        }
      }
    }
  }
  .el-dialog__footer {
    text-align: center;
    padding-top: 0;
    padding-bottom: 35px;
    .el-button {
      width: 300px;
      height: 40px;
      border-radius: 4px;
      background: #ffdb51;
      color: #333;
      border: none;
    }
  }
  .close {
    position: absolute;
    width: 30px;
    height: 30px;
    bottom: -40px;
    left: 50%;
    transform: translateX(-50%);
  }
}
.bargin-dialog {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1002;
  background: rgba(0, 0, 0, 0.5);
  .lottie {
    margin: 30vh auto 0 !important;
  }
}
</style>
<style>
.el-message {
  z-index: 5000 !important;
}
</style>
